<div class="card">
    <div class="card-body">
        <h5 class="card-title">PAD</h5>
        <h6 class="card-subtitle mb-2 text-muted">Plataforma Aeroplantas Digital</h6>
        <p class="card-text">Aplicación Versión: {{versionApp}}</p>   
        <p class="card-text">Angular versión: {{versionAngular}}</p>   
    </div>
</div>